document.addEventListener('copy', function(event) {
    const targetElement = event.target;
    if (targetElement.matches('.article-detail, .article-detail *')) {
        const pagelink = "\nZdroj: " + document.location.href;
        event.clipboardData.setData('text', document.getSelection() + pagelink);
        ga('p.send', 'event', 'copy-text', document.location.href, document.getSelection().toString());
        event.preventDefault();
    }
});

window.addEventListener('load',function (e) {
    let elements = document.querySelectorAll('.box-perex');

    elements.forEach((element) => {
        addTargetBlankToLinks(element);
    });
});

function addTargetBlankToLinks(element) {
    let links = element.querySelectorAll('a');
    links.forEach((link) => {
        if(!link.hasAttribute('target') && !link.classList.contains('img-in-text')) {
            link.setAttribute('target','_blank');
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.article-detail__summary');
    if (!container) return;
    var summary = container.querySelector('.content');
    var header = container.querySelector('.article-detail__summary-header');
    var actions = container.querySelector('.article-detail__summary-actions') || header;
    if (!summary || !header) return;

    // Ensure block formatting so transitions work correctly
    summary.style.display = 'block';
    // Ensure it has an id for aria-controls
    if (!summary.id) {
        summary.id = 'article-summary-content';
    }

    // Prepare animated collapse/expand
    summary.style.overflow = 'hidden';
    summary.style.opacity = '1';
    summary.style.maxHeight = 'none';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'summary__toggle';
    btn.setAttribute('aria-controls', summary.id);
    btn.setAttribute('aria-expanded', 'true');
    btn.textContent = 'skrýt';

    btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
            // Collapse with animation
            var currentHeight = summary.scrollHeight;
            summary.style.maxHeight = currentHeight + 'px';
            // Force reflow to apply the starting height before collapsing
            void summary.offsetHeight;
            summary.style.maxHeight = '0px';
            summary.style.opacity = '0';
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = 'zobrazit';
            // mark container as collapsed to tweak spacing in CSS
            container.classList.add('is-collapsed');
        } else {
            // Expand with animation
            summary.style.maxHeight = summary.scrollHeight + 'px';
            summary.style.opacity = '1';
            btn.setAttribute('aria-expanded', 'true');
            btn.textContent = 'skrýt';
            // remove collapsed state, restore default spacing
            container.classList.remove('is-collapsed');
        }
    });

    // After expanding finishes, allow natural height
    summary.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'max-height') {
            var isExpanded = btn.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                summary.style.maxHeight = 'none';
            }
        }
    });

    // Append the toggle button into header actions (right side)
    actions.appendChild(btn);
});
